  

  import {
    Box,
    Button,
    CircularProgress,
    Modal,
    Typography,
  } from "@mui/material";
  import React, { useState } from "react";
  import { modalstyle } from "./PopupsStyling";
   
  import { useDispatch } from "react-redux";
 
  import { errortost, sucesstost } from "../Alerts/CustomAlert";
import { DeletePriceRange, GetPriceGrouprange } from "../../Redux/Slices/Sessions/Session.action";
  const DeleteRange = ({ modalcontrols }) => {
    let { isdelete, closedelete, deleteselected } =
      modalcontrols;
      
    let dispatch = useDispatch();
    let [loading, setloading] = useState(false)

    let deletethisfile = () => {
      let deleteitemdata = new FormData();
      deleteitemdata.append("status", 0);
      deleteitemdata.append("discount_id", deleteselected?.id); 
      setloading(true)
      dispatch(
        DeletePriceRange(deleteitemdata)
      )
        .unwrap()
        .then((result) => {
          setloading(false);
          if (result?.s === 1) {
            sucesstost(result?.m||"Deleted Sucessfully !");
            dispatch(
                GetPriceGrouprange() 
            )

            closedelete();
          } else {
            errortost(result?.m||"Something wents wrong please try again !");
            setloading(false);
            closedelete();
          }
        })
    }
    
    return (
      <>
        <Modal open={isdelete} onClose={closedelete}>
          <Box
            sx={{
              ...modalstyle,
              borderRadius: "10px",
              width: { xs: "50vw", md: "350px" },
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Typography
              sx={{
                color: "#000",
                fontFamily: "Poppins",
                display: "flex",
                gap: "5px",
              }}
            >
              Want to Delete this discount range{" "}
              
            </Typography>
  
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "13px",
                padding: "10px",
                background: "rgba(128, 128, 128, 0.15)",
                borderRadius: "10px",
              }}
            >
               
  
              <Typography sx={{ color: "#000", textAlign: "center" }}>
            Min:{ deleteselected?.min_amount
                 }  -    Max:{ deleteselected?.max_amount
                 }{" "}

              </Typography>
            </Box>
  
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Button
                onClick={deletethisfile}
                sx={{
                  textTransform: "capitalize",
                  mt: "10px",
                  width: "100%",
                  borderRadius: "14px",
                  background: "#FF1607",
                  color: "#fff",
                  padding: "8px",
                  height: "50px",
                  "&:hover": {
                    background: "#A30000",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress sx={{ color: "#fff" }} />
                ) : (
                  <Typography>Delete</Typography>
                )}
              </Button>
              <Button
                onClick={() => closedelete()}
                sx={{
                  textTransform: "capitalize",
                  mt: "10px",
                  borderRadius: "14px",
                  background: "#E8E8E8",
                  width: "100%",
                  color: "#000",
                  padding: "8px",
                  "&:hover": {
                    background: "#B0B0B0",
                  },
                }}
              >
                No
              </Button>
            </Box>
          </Box>
        </Modal>
      </>
    );
  };
  
  export default DeleteRange;
  